export const valueIsMultiSelectable = (kind, operator) =>
  (["equal", "not_equal"].includes(operator) && kind == "SortProxy") ||
  [
    "Company",
    "Contact",
    "InternalContact",
    "Lookup",
    "Portfolio",
    "User",
    "Text",
  ].includes(kind)

export const valueIsNumerical = (kind) =>
  ["Number", "Money", "Area", "Length", "Distance"].includes(kind)

const operatorSets = [
  {
    kinds: ["Number", "Money", "Area", "Length"],
    operators: [
      {
        value: "less_than",
        label: "less than",
      },
      { value: "equal", label: "equal" },
      {
        value: "greater_than",
        label: "more than",
      },
      {
        value: "range",
        label: "between",
      },
      {
        value: "empty",
        label: "is empty",
      },
      {
        value: "not_empty",
        label: "is not empty",
      },
    ],
  },
  {
    kinds: ["SortProxy"],
    operators: [
      {
        value: "less_than_or_equal",
        label: "at or before",
      },
      {
        value: "greater_than_or_equal",
        label: "at or after",
      },
      { value: "equal", label: "includes" },
      { value: "not_equal", label: "excludes" },
    ],
  },
  {
    kinds: ["Date"],
    operators: [
      {
        value: "range",
        label: "in",
      },
      {
        value: "less_than",
        label: "before",
      },
      {
        value: "greater_than",
        label: "after",
      },
      {
        value: "empty",
        label: "is empty",
      },
      {
        value: "not_empty",
        label: "is not empty",
      },
    ],
  },
  {
    kinds: [
      "Company",
      "Contact",
      "InternalContact",
      "Lookup",
      "Portfolio",
      "User",
      "Text",
    ],
    operators: [
      { value: "equal", label: "include" },
      { value: "not_equal", label: "exclude" },
      {
        value: "empty",
        label: "is empty",
      },
      {
        value: "not_empty",
        label: "is not empty",
      },
    ],
  },
  {
    kinds: ["Boolean"],
    operators: [
      { value: "equal", label: "equal" },
      {
        value: "empty",
        label: "is empty",
      },
      {
        value: "not_empty",
        label: "is not empty",
      },
    ],
  },
  {
    kinds: ["Distance"],
    operators: [
      {
        value: "less_than",
        label: "less than",
      },
      {
        value: "greater_than",
        label: "more than",
      },
      {
        value: "empty",
        label: "is empty",
      },
      {
        value: "not_empty",
        label: "is not empty",
      },
    ],
  },
]

export function conditionFromFormValue(field, formValue) {
  return {
    field_id: field?.id,
    operator: formValue.operator ? formValue.operator.value : undefined,
    value:
      formValue.operator?.value !== "range"
        ? formValue.value
        : [formValue.minValue, formValue.maxValue],
    match_blank: formValue.match_blank
      ? formValue.match_blank.value
      : undefined,
  }
}

export function getOperators(kind) {
  return operatorSets.find((el) => el.kinds.includes(kind)).operators
}
